import { createIntl, createIntlCache, type IntlShape } from 'react-intl';
import { selectDisplayMessages, selectLocale } from '../../store/lang/langSelectors';
import { config } from '../config';
import type { Store } from '@reduxjs/toolkit';

let intl: IntlShape | null = null;

export const initIntl = (store: Store) => {
    const userLocale = selectLocale(store.getState());
    const messages = selectDisplayMessages(store.getState());

    const cache = createIntlCache();

    intl = createIntl(
        {
            locale: userLocale,
            defaultLocale: config.login.defaultLocale,
            messages,
        },
        cache
    );
};

export const getIntl = () => {
    if (!intl) {
        throw new Error('Intl not initialized.');
    }
    return intl;
};
